export default __webpack_public_path__ + "static/media/plain-sticker-f.004257d2.png";